<div class="gray-font-color font-family display-text">
  <div class="header-navigation-back">
    <mat-icon (click)="onNavigateToIdentityStart()">arrow_back</mat-icon>
    <span class="title">Drivers License Scan</span>
  </div>

  <div class="font-family" class="loading-gif padding-bottom-xlg">
    @if (!clientToken) {
      <div>
        <div >
          <img src="/assets/icons/FleetOperate load.gif" />
        </div>
        <div >Loading..</div>
      </div>
    }

    @if (clientToken) {
      <div class="berbix-launch">
        <lib-berbix clientToken="{{ clientToken }}" (flowCompleted)="complete()"> </lib-berbix>
      </div>
    }
  </div>
</div>
